import { authHttp } from '../http'
import * as routes from '../../routes/registration.routes'
import { errorHandler } from '../../../util/error.service'

export async function postImportCompanyXml(data) {
  try {
    const response = await authHttp().post(routes.urlPostCompaniesImport, data)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
